import EventClass from '../utils/event-class';

export default class ResponsiveTables extends EventClass {
    constructor() {

        super();

        this._isActive = false;
        this._$el = $(document.querySelectorAll('[data-responsive-table]'));
        if (this._$el.length > 0) {
            // proxy
            var that = this,
                a = [];
            // create element wrapper for control   
            this._$el.each(function (index) {

                let view,
                    $el = $(this),
                    type = $el.data('stack');

                // stack or scroll
                if (type)
                    view = new ResponsiveTableStack($(this));
                else
                    view = new ResponsiveTableScroll($(this));

                a.push(view);
            });
            this._views = a;
            this._isActive = true;
        }
    }
}

// Wrapper view class
class ResponsiveTableStack extends EventClass {

    constructor($el) {
        super();
        this._$el = $el;

        if (this._$el.length > 0) {

            this._$window = $(window);
            // proxy
            this.__resize = this._resize.bind(this);

            this._init();
        }
    }


    get $el() {
        return this._$el;
    }

    get el() {
        return this._$el[0];
    }



    _init() {
        // this provides scroll
        this._$wrapper = this._createWrapper(this._$el, '<div class="table-wrapper"></div>');

        this._excKey = this._$el.data('exclude-key');
        this._tableStacked = this._createStackedView();
        this._$wrapper.append(this._tableStacked);
        // listeners    
        window.addEventListener('resize', this.__resize);
        window.addEventListener('orientationchange', this.__resize);
        this._resize();
    }



    // create a div element around the table
    _createWrapper($el, divStr) {
        return $el.wrap(divStr).parent();
    }


    _createStackedView() {
        var html = '';
        for (var i = 1; i < this.el.rows.length; i++) {
            html += '<table class="stacked-view">';
            html += this._getRow(i);
            html += '</table>';
        }
        return html;
    }


    // get column widths
    _getRow(rowIndex, excKey) {
        var html = '';
        for (var i = 0; i < this.el.rows[rowIndex].cells.length; i++) {
            html += '<tr>';
            if (!excKey) {
                html += '<td class="tb-key">' + this.el.rows[0].cells[i].innerHTML + '</td>';
            }
            html += '<td class="tb-value">' + this.el.rows[rowIndex].cells[i].innerHTML + '</td>';
            html += '</tr>';
        }
        return html;
    }



    _resize() {
        var stack = this._$el.outerWidth() > this._$wrapper.outerWidth()

        if (stack && !this._$wrapper[0].classList.contains('show-stacked-view')) {
            this._$wrapper[0].classList.add('show-stacked-view');
        }
        if (!stack && this._$wrapper[0].classList.contains('show-stacked-view')) {
            this._$wrapper[0].classList.remove('show-stacked-view');
        }


        //clearTimeout(this._int);
        // this._int = setTimeout(this.__update, 250);
    }



}


// Wrapper view class
class ResponsiveTableScroll extends EventClass {

    constructor($el) {
        super();
        this._$el = $el;

        if (this._$el.length > 0) {

            let val = parseInt(this._$el.data('sticky-columns'));
            this._stickyColumns = val == NaN ? 0 : val;

            this._$window = $(window);

            // elements
            this._$wrapper;
            this._fauxTable;
            this._$stickyWrapper;

            // proxy
            this.__resize = this._resize.bind(this);

            this._init();
        }
    }

    _init() {
        // this provides scroll
        this._$wrapper = this._createWrapper(this._$el, '<div class="table-wrapper"></div>');

        // this create sticky columns
        if (this._stickyColumns > 0) {
            this._fauxTable = this._createStickyColumn();
            this._$stickyWrapper = this._createWrapper(this._$wrapper, '<div class="table-sticky-wrapper"></div>');
            this._$stickyWrapper.append(this._fauxTable);
            // listeners    
            window.addEventListener('resize', this.__resize);
            window.addEventListener('orientationchange', this.__resize);
            this._resize();
        }
    }


    get $el() {
        return this._$el;
    }

    get el() {
        return this._$el[0];
    }


    // create a div element around the table
    _createWrapper($el, divStr) {
        return $el.wrap(divStr).parent();
    }


    _createStickyColumn() {

        // clone the table          
        var clone = this._$el[0].cloneNode(true);
        this._removeExcessColumns(clone.querySelectorAll('tr > th:nth-child(n+' + (this._stickyColumns + 1) + ')'));
        this._removeExcessColumns(clone.querySelectorAll('tr > td:nth-child(n+' + (this._stickyColumns + 1) + ')'));
        clone.classList.add('table-sticky');
        return clone;
    }


    _removeExcessColumns(cols) {
        if (cols == undefined) return false;
        // Remove all unecessary columns  
        for (var i = 0; i < cols.length; i++) {
            var pNode = cols[i].parentNode;
            // remove children 
            try {
                pNode.removeChild(cols[i]);
            } catch (e) {
                console.warn(e)
            }
        }
    }


    // get column widths
    _setColumnWidths(rowIndex) {
        var n = 0;
        for (var i = this._stickyColumns - 1; i >= 0; i--) {
            n += this.el.rows[rowIndex].cells[i].offsetWidth;
        }
        this._fauxTable.style.width = n + 'px';
    }


    // get column widths
    _setColumnHeight() {
        for (var i = this.el.rows.length - 1; i >= 0; i--) {
            this._fauxTable.rows[i].cells[0].style.height = this.el.rows[i].offsetHeight + 'px';
        }
    }


    _resize() {
        if (this._stickyColumns > 0) {
            var visible = this._$el.outerWidth() > this._$wrapper.outerWidth();
            this._setColumnWidths(0) + 'px';
            this._setColumnHeight();
            if (visible && !this._fauxTable.classList.contains('is-active')) {
                this._fauxTable.classList.add('is-active');
            }

            if (!visible && this._fauxTable.classList.contains('is-active')) {
                this._fauxTable.classList.remove('is-active');
            }
        }
    }


}
